<template>
  <v-app>
    <v-container>
      <router-view></router-view>
      <notification/>
      <loader/>
    </v-container>
    <bottom-navigation v-if="this.$route.path !== '/reports/print'"/>
  </v-app>

</template>

<script>
  import BottomNavigation from './Bottom-navigation'
  import Loader from '../Service/Loader'
  import Notification from '../Service/Notification'

  export default {
    async created() {
      await this.$store.dispatch('fetchDepartments')
      await this.$store.dispatch('fetchEmployees')
      await this.$store.dispatch('fetchAppInfo')
    },
    components: {
      BottomNavigation,
      Loader,
      Notification
    }
  }
</script>
